import { Injectable, NgZone } from '@angular/core';
import { Unsubscribable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MediaQueryService {
  ngZone: NgZone;
  constructor(ngZone: NgZone) {
    this.ngZone = ngZone;
  }

  addListener(
    query: string,
    callback: (matches: boolean) => void,
  ): Unsubscribable {
    const mediaQueryList = globalThis.matchMedia(query);

    callback(mediaQueryList.matches);
    mediaQueryList.onchange = (event) => {
      this.ngZone.run(() => {
        callback(event.matches);
      });
    };
    return { unsubscribe: () => (mediaQueryList.onchange = null) };
  }
}
